import axios from 'axios';

import { TELEPHONY_API_ENDPOINT } from 'constants/api';

const telephonyAPI = axios.create({
  baseURL: TELEPHONY_API_ENDPOINT,
});

export default telephonyAPI;
